import { isString } from 'lodash';

import { FormContextValues, isBase32 } from '@dreryk/react-common';
import {
   Notification,
   NotificationSize,
   NotificationType,
   PasswordInput as PasswordInputComponent,
   StyledFlex,
} from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

export const MFA_SECRET_PLACEHOLDER_VALUE = 'PLACEHOLDERSECRETFORBASE32VALIDATIONTEXTDUMMYEXAMPLEPLACEHOLDER=';
const MFA_SECRET_FIELD_NAME = 'mfaSecret';
const MFA_SECRET_MAX_LENGTH = 64;

export type MfaSecretFormBeanPart = { [MFA_SECRET_FIELD_NAME]: string | null };

type MfaSecretFieldProps = Pick<FormContextValues<MfaSecretFormBeanPart>, 'register' | 'setValue' | 'watch'> & {
   mfaSecretPresent: boolean;
};

export const MfaSecretField = (props: MfaSecretFieldProps): JSX.Element => {
   return (
      <StyledFlex gap={8} direction={'column'}>
         <PasswordInputComponent
            label={nfzLoginTranslationKeys.mfaSecret.label}
            controller={props.register(MFA_SECRET_FIELD_NAME, {
               required: true,
               maxLength: MFA_SECRET_MAX_LENGTH,
               validate: (value) => {
                  if (isString(value) && !isBase32(value)) {
                     return nfzLoginTranslationKeys.mfaSecret.validation.invalidValue;
                  }

                  return undefined;
               },
            })}
            testId={MFA_SECRET_FIELD_NAME}
            defaultValue={props.mfaSecretPresent ? MFA_SECRET_PLACEHOLDER_VALUE : null}
         />

         <Notification
            testId={'mfaSecretInfo'}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
            label={nfzLoginTranslationKeys.enterMfaSecret}
         />
      </StyledFlex>
   );
};
